<template>
    <div class="addProp-box">
        <div class="congrats">
            <h1 class="congrats">{{$t('addProperty.Congratulations')}}</h1>
            <p class="congrats-desc">{{$t('addProperty.CongratsDesc')}}</p>
            <p class="congrats-desc">{{$t('addProperty.CongratsDesc1')}}</p>
        </div>
        <el-button type="primary" class="btn-add" @click="goToStep">
            <i class="icon-add-property el-icon--left"></i>
            {{$t('addProperty.AddNewProperty')}}
        </el-button>
        <el-button
            type="primary"
            class="btn-white"
            plain
            @click="viewPortfolio"
        >{{$t('addProperty.ViewPortfolio')}}</el-button>
    </div>
</template>
<script>
export default {
    name: "addProp4",
    data() {
        const $t = this.$t.bind(this);
        return {};
    },

    methods: {
        goToStep() {
            this.$emit("goToStep", {
                step: 1,
                form: {}
            });
        },

        viewPortfolio() {
            this.$emit("goToPortfolio", "portfolio");
        }
    }
};
</script>
<style lang="scss" scoped>
.addProp-box {
    .congrats {
        padding: 16px;
        margin-bottom: 30px;
        border-radius: 4px;
        box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
        background-color: #f0f3ff;
        h1 {
            font-family: GothamMedium;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.06;
            color: #333333;
            margin-bottom: 16px;
        }
        .congrats-desc {
            font-family: GothamBook;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.06;
            color: #333333;
            &:first-of-type {
                margin-bottom: 32px;
            }
        }
    }
    .btn-add {
        height: 50px;
        line-height: 50px;
        font-family: GothamMedium;
        font-size: 14px;
        line-height: 1;
        text-align: center;
        color: var(--white);
        margin-bottom: 16px;
        .icon-add-property {
            width: 14px;
            height: 14px;
            display: inline-block;
            background: url("../../../../website_20/static/img/addProp/icon-add-property-white.svg")
                no-repeat;
            margin-bottom: -2px;
        }
    }
    .btn-white {
        border-radius: 4px;
        margin: 0;
        background: #fff;
        border: solid 1px #e0e7ff;
        font-family: GothamMedium;
        font-size: 14px;
        color: var(--windows-blue);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/addProp4.vue